<template>
    <div class="scd">
        <div class="header1 page-header">
            <h1 class="title">売上ランキング</h1>
            <div style="display: inline-block">
                <OpSelectFiscalyear
                    v-model="fiscalyear"
                    label="会計年度"
                    @input="changedYear"
                    :company="getCompany()"
                    required
                    hideheader
                />
            </div>
            <div style="display: inline-block">
                <OpRadioGroup
                    v-model="state.perioddiv"
                    v-slot="{ item }"
                    :choices="perioddivlist"
                    :itemKey="item => item.key"
                    @input="changedFilter"
                >
                    {{ item.name }}
                </OpRadioGroup>
            </div>
        </div>
        <div class="header2">
            <div class="soposts">
                <!-- 受注ステータス -->
                <OpDivMultiSelector
                    label="受注ステータス"
                    v-model="salesorder_status"
                    :divlist="sostslist"
                    name="sosts"
                    divViewType="status"
                    @input="changedPeriod"
                />
            </div>
            <div>
                <OpDateRangeTextField
                    label="対象期間"
                    v-model="dts"
                    name="dates"
                    required="both"
                    :noadjust="true"
                    @input="changedPeriod"
                />
            </div>
            <div style="padding-top: 10px; padding-left:10px;">
                <button @click="download" :disabled="loading">
                    <IconBase
                        iconName="Excel"
                        width="24"
                        height="24"
                        visibleName
                        v-slot="{ viewbox }"
                        :disabled="loading"
                    >
                        <IconDownload @viewbox="viewbox" />
                    </IconBase>
                </button>
            </div>
            
        </div>

        <div class="body">
            <div>
                <SalesRankingTable
                    :caption="formatCaption()"
                    :fiscalyear="fiscalyear.key"
                    :perioddiv="state.perioddiv"
                    :period="dts"
                    :refreshcount="refreshCount"
                    :salesorder_status="salesorder_status"
                />
            </div>
        </div>
    </div>
</template>

<script>
import SalesRankingTable from "@/views/sales-ranking/SalesRankingTable.vue";
import OpSelectFiscalyear from "@/components/OpSelectFiscalyear.vue";
import OpDateRangeTextField from "@/components/OpDateRangeTextField.vue";
// import OpSelectDepartment from "@/components/OpSelectDepartment.vue";
import OpDivMultiSelector from "@/components/OpDivMultiSelector.vue";
// import OpCheckbox from "@/components/OpCheckbox.vue";
import OpRadioGroup from "@/components/OpRadioGroup.vue";
import IconBase from "@/components/icons/IconBase.vue";
import IconDownload from "@/components/icons/IconDownload.vue";
import DateUtils from "@/DateUtils";

export default {
    name: "SalesCostDetail",
    components: {
        SalesRankingTable,
        OpSelectFiscalyear,
        OpDateRangeTextField,
        // OpSelectDepartment,
        OpDivMultiSelector,
        OpRadioGroup,
        // OpCheckbox,
        IconBase,
        IconDownload
    },
    props: {},
    data: function() {
        let comp = this.getCompany();
        let fh = DateUtils.getFiscalYearAndHalfsignToday(comp);
        let dts = DateUtils.getFiscalRangeDate(comp, fh.fiscalyear, 0);
        // let mlist = DateUtils.getYearMonthList(dts.start, dts.end);
        // let today = new Date();
        return {
            fiscalyear: fh.fiscalyear,
            dts: dts,
            startdate: dts.start,
            enddate: dts.end,
            salesorder_status: ["A", "B", "C", "D"],
            sostslist: {},
            refreshCount: 1,
            perioddivlist: [
                { key: 0, name: "通期" },
                { key: 1, name: "上期" },
                { key: 2, name: "下期" }
            ],
            state: {
                perioddiv: fh.halfsign
            },
            changing: false
        };
    },
    methods: {
        changedFilter: function() {
            let y = null;
            if (this.fiscalyear.key) {
                y = this.fiscalyear;
            } else {
                y = { key: this.fiscalyear };
            }
            this.changedYear(y);
        },
        changedYear: function(year) {
            if (year != null) {
                if (this.state.perioddiv >= 0) {
                    let frange = DateUtils.getFiscalRangeDate(
                        this.getCompany(),
                        year.key,
                        this.state.perioddiv
                    );
                    this.dts = frange;
                } else {
                    let frange = DateUtils.getFiscalRangeDate(
                        this.getCompany(),
                        year.key,
                        0
                    );

                    let yyyy = frange.start.getFullYear();
                    let dtss = this.dts;
                    let ds = new Date(dtss.start);
                    let dsy = ds.getFullYear();
                    ds.setFullYear(dsy + (yyyy - dsy));

                    let de = new Date(dtss.end);
                    let dey = de.getFullYear();
                    de.setFullYear(dey + (yyyy - dey));

                    this.dts = { start: ds, end: de };
                }
                this.startdate = this.dts.start;
                this.enddate = this.dts.end;
            }
        },
        changedPeriod: function() {
            this.startdate = this.dts.start;
            if (!DateUtils.isValidDate(this.startdate)) {
                return;
            }
            
            this.enddate = this.dts.end;
            if (!DateUtils.isValidDate(this.enddate)) {
                return;
            }

            let fps = DateUtils.getFiscalPeriod(
                this.getCompany(),
                this.startdate,
                this.enddate
            );
            this.fiscalyear = { key: fps.fiscalyear, value: "aaa" };
            this.state.perioddiv = fps.perioddiv;
            this.refreshCount += 1;
        },
        formatCaption: function() {
            return "";
        },
        filterSopolist: function() {
            let slist = this.divs["sosts"];
            let ss = {};
            for (let v in slist) {
                if (v != "Z") {
                    ss[v] = slist[v];
                }
            }
            this.sostslist = ss;
        },
        download: function() {
            // let params = this.makeParams();
            let y = this.fiscalyear.key;
            if (!y) y = this.fiscalyear;
            let filename = "売上ランキング";
            // filename += "_" + y + "年度";
            // for (const pdiv of this.perioddivlist) {
            //     if (pdiv.key == this.state.perioddiv) {
            //         filename += pdiv.name;
            //         break;
            //     }
            // }
            // filename = filename.replace(/,/g, "");

            const sd = this.startdate;
            const ed = this.enddate;
            const params = [];
            const period = this.dateTo8Str(sd) + "-" + this.dateTo8Str(ed);
            params["period"] = period;
            filename += "_" + period;
            if (this.salesorder_status && this.salesorder_status.length > 0) {
                params["sosts"] = this.salesorder_status;
                filename += "_" +this.salesorder_status;
            }
            filename += ".xlsx";

            filename = filename.replace(/,/g, "");

            this.downloadData(
                this.makeurl("sales-ranking", "xlsx", params),
                filename
            );
        }
    },
    created: async function() {
        this.loading = true;
        let dd = this.loaddivs("sosts", "posts");
        if (dd instanceof Promise) {
            dd.then(this.filterSopolist);
        } else {
            this.filterSopolist();
        }
        this.changedFilter();
        this.loading = false;
    }
};
</script>

<style scoped>
.header1 {
    height: 80px;
    margin: inherit auto;
    z-index: 4;
}
.header2 {
    position: sticky;
    top:80px;
    height: 80px;
    display:flex;
    justify-content: center;
    width:100%;
    z-index: 2;
    column-gap: 20px;
}
.page-header {
    left: 0px;
    width: calc(100% - 10px);
}

.mycontents {
    padding-top: 80px;
}

.downloadblock {
    text-align: center;
    display: block;
}
.downloadblock button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
.body {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: center;
    width:100%;
    margin-top:-70px;
}
</style>
